import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { RefreshCcw } from "lucide-react";

export default function AdminAudit() {
  const [data, setData] = useState({ items: [], total: 0 });
  const [filterAction, setFilterAction] = useState("");
  const [filterActor, setFilterActor] = useState("");

  const load = async () => {
    const params = new URLSearchParams();
    if (filterAction) params.set("action", filterAction);
    if (filterActor) params.set("actor", filterActor);
    const { data: d } = await api.get(`/admin/audit?${params}`);
    setData(d);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  return (
    <div data-testid="admin-audit-page">
      <div className="flex items-end justify-between border-b border-border pb-4">
        <div>
          <div className="font-mono text-xs uppercase tracking-wider text-[#002FA7]">// Audit log</div>
          <h1 className="mt-1 font-display text-2xl font-black tracking-tight">Journal d'audit</h1>
          <p className="mt-1 text-sm text-muted-foreground">Toutes les actions admin sensibles sont tracées ici.</p>
        </div>
        <div className="flex gap-2">
          <Input placeholder="action (ex: user.)" value={filterAction} onChange={(e) => setFilterAction(e.target.value)} className="w-44 rounded-sm font-mono text-xs" data-testid="audit-filter-action" />
          <Input placeholder="actor email" value={filterActor} onChange={(e) => setFilterActor(e.target.value)} className="w-56 rounded-sm font-mono text-xs" data-testid="audit-filter-actor" />
          <Button onClick={load} variant="outline" className="rounded-sm gap-2" data-testid="audit-reload"><RefreshCcw className="h-4 w-4" /> Filtrer</Button>
        </div>
      </div>

      <div className="mt-4 overflow-x-auto border border-border">
        <table className="w-full text-left text-sm">
          <thead className="bg-accent/30 font-mono text-[11px] uppercase text-muted-foreground">
            <tr>
              <th className="border-b border-border p-2">Date</th>
              <th className="border-b border-border p-2">Actor</th>
              <th className="border-b border-border p-2">Action</th>
              <th className="border-b border-border p-2">Target</th>
              <th className="border-b border-border p-2">Payload</th>
            </tr>
          </thead>
          <tbody>
            {data.items.map((e) => (
              <tr key={e.id} className="border-b border-border last:border-0">
                <td className="p-2 font-mono text-[11px] text-muted-foreground">{new Date(e.created_at).toLocaleString()}</td>
                <td className="p-2 text-xs">{e.actor_email || e.actor_id}</td>
                <td className="p-2 font-mono text-xs">{e.action}</td>
                <td className="p-2 font-mono text-xs">{e.target_type}{e.target_id ? `/${e.target_id.slice(0, 8)}` : ""}</td>
                <td className="p-2 font-mono text-[10px] text-muted-foreground"><pre className="max-w-md overflow-hidden whitespace-pre-wrap">{Object.keys(e.payload || {}).length ? JSON.stringify(e.payload).slice(0, 200) : "—"}</pre></td>
              </tr>
            ))}
            {data.items.length === 0 && (
              <tr><td colSpan="5" className="p-8 text-center font-mono text-xs text-muted-foreground">Aucune entrée</td></tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="mt-2 text-right font-mono text-[11px] text-muted-foreground">{data.total} entrées au total</div>
    </div>
  );
}
